/**
 * @fileoverview TextInput component
 *
 * It can have a password visibility button that switches between type `text` and `password`.
 */

 import { svgIconSpriteUrl } from '../../../utils/globals';

 class TextInput {
     constructor() {
         this.state = {
             passwordReveal: false
         }
         this.initPasswordReveal()
     }
 
     initPasswordReveal() {
         const passwordButton = document.querySelector('.js-lta-text-ss-venue-input--btn-eye');
 
         if (passwordButton !== null) {
             const input = passwordButton.previousElementSibling;
             const buttonIconSvgUse = document.querySelector('.js-lta-text-ss-venue-input--btn-eye use');
 
             passwordButton.addEventListener('click', (e) => {
                 e.preventDefault();
                 buttonIconSvgUse.setAttribute('xlink:href', `${svgIconSpriteUrl}#${this.state.passwordReveal ? 'eye-fill' : 'eye-slash-fill'}`);
                 input.setAttribute('type', this.state.passwordReveal ? 'password' : 'text');
                 this.state.passwordReveal = !this.state.passwordReveal;
             });
         }
     }
 }
 
 const globalTextInput = new TextInput();
 
 export default globalTextInput;
 